import React from 'react';

import Price from '../price';

import { IPriceAndQuantityProps } from './types';

export const PriceAndQuantity: React.FC<IPriceAndQuantityProps> = ({
  item,
  isOffer,
  rewardApplied,
}) => <Price item={item} isOffer={isOffer} rewardApplied={rewardApplied} />;
